import {GET, POST} from "@/services/gateway";

const list = ({pagination, search, filter}) => {
  return POST('dropbox/user/list', {pagination, search, filter});
}

const getStatus = () => {
  return GET('dropbox/user/status');
}

const refresh = () => {
  return GET('dropbox/user/refresh');
}

const backupAll = () => {
  return GET('dropbox/user/backup/all')
}

const backupAllActiveSeats = () => {
  return GET('dropbox/user/backup/active-seats')
}

const protectAll = () => {
  return POST('dropbox/user/protect');
}

const unprotectAll = () => {
  return POST('dropbox/user/unprotect');
}
const changeStatus = ({status, id}) => {
  return POST('dropbox/user/userstatus/change', {status, id});
}

const exportSnapshot = (filter, search, pagination) => {
  const currentDate = new Date();

  return POST('dropbox/user/export', {filter, search, pagination, TimeZoneOffset: currentDate.getTimezoneOffset()})
}

export {
  list,
  refresh,
  getStatus,
  protectAll,
  unprotectAll,
  backupAllActiveSeats,
  backupAll,
  changeStatus,
  exportSnapshot
}
